import React from 'react';

const DebugLog = ({ debugLogs, setDebugLogs, showDebugLogs, setShowDebugLogs }) => {
    if (debugLogs.length === 0) return null;

    return (
        <div className="max-w-6xl mx-auto px-6">
            <div className="bg-white rounded-lg shadow-lg p-4 mt-6">
                <div className="flex justify-between items-center mb-2">
                    <h3 className="font-semibold text-gray-800">Log di Debug</h3>
                    <div className="flex gap-2">
                        <button
                            onClick={() => setDebugLogs([])}
                            className="text-xs bg-red-100 hover:bg-red-200 text-red-700 px-3 py-1 rounded transition-colors"
                        >
                            Cancella Log
                        </button>
                        <button
                            onClick={() => setShowDebugLogs(!showDebugLogs)}
                            className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded transition-colors"
                        >
                            {showDebugLogs ? 'Nascondi Log' : 'Mostra Log'}
                        </button>
                    </div>
                </div>

                {showDebugLogs && (
                    <div className="bg-gray-900 text-gray-100 p-4 rounded font-mono text-xs overflow-x-auto max-h-96 overflow-y-auto">
                        {debugLogs.map((log, i) => (
                            <div
                                key={i}
                                className={`mb-2 ${log.type === 'error' ? 'text-red-400' :
                                    log.type === 'success' ? 'text-green-400' :
                                        log.type === 'warning' ? 'text-yellow-400' :
                                            'text-gray-300'
                                    }`}
                            >
                                <span className="text-gray-500">[{log.timestamp}]</span> {log.message}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DebugLog;
